import BKV from "../bkv/bkv";
import { t } from "../i18n/index";
import { crc16 } from "../bkv/parse";
import { hexToArrayBuffer, arrayBufferToHex } from "../js/utils";


const Const = {
    TEMPERATURE_SENSOR_NAME: [
        'Cell Temp 1',
        'Cell Temp 2',
        'Cell Temp 3',
        'PCB Temp 1',
        'DSG Mos Temp 1',
        'CHG Mos Temp 1',
        'Pre-Start Temp 1',
        'Pre-Charge Temp 1',
    ],

    BATTERY_STATUS: [
        // 内部状态 INTERNAL_STATE
        { '0': 'USB输出', '1': '尾灯', '2': '充电器识别状态', '3': '充电器连接状态', '4': '预充电路', '5': '预放电路', '6': '放电MOS', '7': '充电MOS', },
        { '7': '电池停止充电状态', },
        // 错误 ERROR
        { '0': '保护 IC 出错', '1': '电芯掉线', '2': '电芯不平衡', '3': '计量出错', '4': '记录出错', '5': '时钟出错', '6': '放电 MOS 损坏', '7': '充电 MOS 损坏', },
        { '0': '过充错误', '1': '初级过放', '2': '二级过放错误', '3': '初级过流', '4': '二级过流', '5': '充电过流', '6': '软启动失败', '7': '预充超时警告', },
        { '0': 'MOS 温度传感器故障', '1': '电芯温度传感器故障', '2': '放电过温', '3': '充电过温', '4': '放电欠温', '5': '充电欠温', '6': '放电 MOS 过温', '7': '充电 MOS 过温', },
        { '0': '软启动电路过温', '4': '三级过流', '6': '配置错误', },
        // 告警 ALARM
        { '0': '保护 IC 出错', '1': '电芯掉线', '2': '电芯不平衡', '3': '计量出错', '4': '记录出错', '5': '时钟出错', '6': '放电 MOS 损坏', '7': '充电 MOS 损坏', },
        { '0': '过充错误', '1': '初级过放', '2': '二级过放错误', '3': '初级过流', '4': '二级过流', '5': '充电过流', '6': '软启动失败', '7': '预充超时警告', }
    ],
    ERROR_MAP: {
        '0': '保护 IC 出错',
        '1': '电芯掉线',
        '2': '电芯不平衡',
        '3': '计量出错',
        '4': '记录出错',
        '5': '时钟出错',
        '6': '放电 MOS 损坏',
        '7': '充电 MOS 损坏',

        '8': '过充错误',
        '9': '初级过放',
        '10': '二级过放错误',
        '11': '初级过流',
        '12': '二级过流',
        '13': '充电过流',
        '14': '软启动失败',
        '15': '预充超时警告',

        '16': 'MOS 温度传感器故障',
        '17': '电芯温度传感器故障',
        '18': '放电过温',
        '19': '充电过温',
        '20': '放电欠温',
        '21': '充电欠温',
        '22': '放电 MOS 过温',
        '23': '充电 MOS 过温',

        '24': '软启动电路过温',
        '25': '',
        '26': '',
        '27': '',
        '28': '三级过流',
        '29': '',
        '30': '配置错误',
        '31': '',
    }
}

function runParser(buf) {
    let buffer = hexToArrayBuffer(buf);

    if (buffer.length < 4) {
        console.log('parser', 'buffer too short');
        return
    }

    let headIndex = buffer.findIndex((e) => e === 0x87);
    if (headIndex < 0) {
        console.log('parser', 'head not exists');
    }

    let fb = buffer.slice(headIndex);
    if (fb.length < 4) {
        console.log('parser', 'frame length too short');
    }

    let length = fb[1];
    if (fb.length < length + 4) {
        console.log('parser', 'frame length not match', fb.length, length + 4);
    }

    let checksum = new DataView(fb.buffer).getUint16(2 + length, false)
    let calculatedChecksum = crc16(fb.slice(1, length + 2));
    if (checksum !== calculatedChecksum) {
        console.log('parser', 'checksum not match');
    }

    let b = BKV.unpack(fb.slice(2, length + 2));
    if (b.code === 0) {
        return b.bkv
    } else {
        console.log("bkv parse fail", b);
    }
}
function publishFrame(frame) {
    let data = {}
    try {
        let items = frame.items()
        for (let index = 0; index < items.length; index++) {
            let item = items[index];
            let k = item.key();
            let v = item.value();
            let str = '', arr = []
            switch(k) {
                case 0x12: data['bms_id'] = item.stringValue(); break;

                case 0x14: data['gsm_signal_strength'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x15: data['gps_signal_strength'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x16: data['gps_satellite_in_view_count'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x17: data['gnss_satellite_used_count'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x21: data['gps_status'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x25: data['location_longitude'] = new DataView(v.buffer).getUint32(0, true); break;
                case 0x26: data['location_latitude']  = new DataView(v.buffer).getUint32(0, true); break;
                case 0x27: data['location_speed'] = new DataView(v.buffer).getUint16(0, true); break;
                case 0x28: data['location_angle'] = new DataView(v.buffer).getUint16(0, true); break;

                case 0x41: data['battery_voltage']  = new DataView(v.buffer).getUint32(0, true); break;
                case 0x42: data['battery_current'] = new DataView(v.buffer).getInt32(0, true); break;
                case 0x43: data['battery_soc'] = new DataView(v.buffer).getUint8(0, true); break;
                case 0x44:
                    for (let i = 0; i < Const.TEMPERATURE_SENSOR_NAME.length; i++) {
                        arr.push(`${Const.TEMPERATURE_SENSOR_NAME[i]}: ${v[i]}`)
                    }
                    data['battery_temperature'] = arr.join(', ');
                    break;
                case 0x45: data['battery_remaining_capacity']  = new DataView(v.buffer).getUint32(0, true); break;
                case 0x46: data['battery_full_charge_capacity']   = new DataView(v.buffer).getUint32(0, true); break;
                case 0x47: data['battery_cycle_count']     = new DataView(v.buffer).getUint32(0, true); break;
                case 0x48: data['battery_rated_capacity'] = new DataView(v.buffer).getUint32(0, true); break;
                case 0x49: data['battery_rated_voltage']  = new DataView(v.buffer).getUint32(0, true); break;
                case 0x50: data['battery_version'] = `软件版本: ${v[0]}${v[1]} 硬件版本: ${v[2]}${v[3]} 固件索引码: ${v[4]}${v[5]}${v[6]}${v[7]}`; break;
                case 0x51: data['battery_manufacture_date'] = `${v[0]}年${v[1]}月${v[2]}日` ; break;
                case 0x53: data['battery_manufacture_name'] = item.stringValue(); break;
                case 0x54: data['battery_name'] = item.stringValue(); break;
                case 0x55: data['battery_chem_id'] = item.stringValue(); break;
                case 0x56: data['bms_bar_code']  = item.stringValue(); break;
                case 0x57:
                    for (let i = 0; i < v.length; i = i+2) {
                        arr.push(`${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}mV`)
                    }
                    data['cell_voltage_list_0'] = arr.join(', ');
                    break;
                case 0x58:
                    for (let i = 0; i < v.length; i = i+2) {
                        arr.push(`${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}mV`)
                    }
                    data['cell_voltage_list_1'] = arr.join(', ');
                    break;
                case 0x59:
                    str += `最大放电电: ${new DataView(v.slice(0,4).buffer).getInt32(0, true)}mAh, `
                    str += `最大充电电流: ${new DataView(v.slice(4,8).buffer).getInt32(0, true)}mAh, `
                    str += `最大电芯电压: ${new DataView(v.slice(8,10).buffer).getUint16(0, true)}mAh, `
                    str += `最小电芯电: ${new DataView(v.slice(10,12).buffer).getUint16(0, true)}mAh, `
                    str += `电池包最大温度: ${new DataView(v.slice(12,13).buffer).getInt8(0, true)}, `
                    str += `电池包最小温度: ${new DataView(v.slice(13,14).buffer).getInt8(0, true)}`
                    data['history'] = str;
                    break;
                case 0x60: data['system_error_status'] = errorCountFilter(v); break;
                case 0x67: data['battery_status'] = batteryStatusFilter(v); break;
                case 0x71: data['iot_temperature'] = new DataView(v.buffer).getUint16(0, true); break;
                case 0x72: data['gprs_total_data_used'] = new DataView(v.buffer).getUint32(0, true); break;
                case 0x73: data['dtu_software_version'] = item.stringValue(); break;
                case 0x74: data['bms_software_version'] = item.stringValue(); break;
                case 0x75: data['bluetooth_mac'] = arrayBufferToHex(v); break;

                case 0xE1: data['iccid'] = item.stringValue(); break;
                case 0xE2: data['imei'] = item.stringValue(); break;
                case 0xE3: data['gprs_apn'] = item.stringValue(); break;
                 case 0xE4: data['bluetooth_password'] = v[0]; break;

            }
        }
    } catch (error) {
        console.log('bkvUnpack error', error);
    }
    return data
}

// 0x60 错误计数 处理
function errorCountFilter(v) {
    const ERROR_MAP = Const.ERROR_MAP
    let parts = []

    for (let i = 0; i < v.length; i = i+2) {
        let name = ERROR_MAP[(i/2) + '']
        if (name) {
            parts.push(`${name}: ${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}次`)
        }
    }

    return parts.join(', ')
}

// 0x67 电池状态 处理
function batteryStatusFilter(value) {
    // console.log('batteryStatusFilter value:', value)

    const BATTERY_STATUS = Const.BATTERY_STATUS

    function getBit(b,i) { // 获取第i位的bit值 并判断
        let bit = (b >> i) & 0x1;
        return bit !== 0;
    }

    let parts = ['\n']
    for (let i = 0; i < BATTERY_STATUS.length; i++) {
        let v = value[i]
        for (const key in BATTERY_STATUS[i]) {
            if (getBit(v, parseInt(key))) {
                parts.push(`[${BATTERY_STATUS[i][key]}]`)
            }
        }
    }
    parts.push(`电池剩余容量百分比: ${value[8]}`)
    parts.push(`电池健康状态百分比: ${value[9]}`)
    parts.push(`电池包总电压: ${new DataView(value.slice(10,14).buffer).getUint32(0, true)}mV`)
    parts.push(`实时电流: ${new DataView(value.slice(14,18).buffer).getUint32(0, true)}mA`)
    parts.push(`实时电芯最高温度: ${value[18]}°`)
    parts.push(`实时电芯最低温度: ${value[19]}°`)
    parts.push(`实时 Mos 管温度: ${value[20]}°`)
    parts.push(`其他温度: ${value[21]}°`)

    let maximum_charge_current_unit = (value[22] >> 6) & (0xFF >> 6)
    switch (maximum_charge_current_unit) {
        case 0: maximum_charge_current_unit = 0.05; break;
        case 1: maximum_charge_current_unit = 0.1; break;
        case 2: maximum_charge_current_unit = 1; break;
        case 3: maximum_charge_current_unit = 2; break;
    }
    let maximum_charge_current = (value[22] >> 0) & (0xFF >> 2)
    parts.push(`允许最大充电电流: ${maximum_charge_current * maximum_charge_current_unit}A`)

    // byte 23： 放电信息 Discharging message Bit7 ~ Bit0: Reserved
    parts.push(`电池循环次数: ${new DataView(value.slice(24,26).buffer).getUint16(0, true)}`)


    return parts.join(', ')
}

export function parse26006Frame(packet) {
    console.log("process frame", packet)

    let items = [];

    let addHead = function (content) {
        items.push(`<span class="item item-head">[${content}]</span>`);
    }

    let addItem = function (key, value) {
        if(key =='纬度' || key == '经度' || key ==' Latitude' || key =='Longitude'){
            value = value / 1000000
        }

        items.push(`<div class="item item-info" style='white-space: pre-warp;'><span style='color:#8E949C;margin-right: 8px'>${key}:</span>${value}</div>`);
    }

    let frame = packet['frame']
    if (!frame) {
        addHead(t(/*非法数据包*/'frame.illegal_data_packet'));
    }



    let parsePayload = function (p) {
        const frameKeyNaming = {
            "bms_id": t("device.bms_id"),

            "bluetooth_mac": t("device.bluetooth_mac"),
            "bms_software_version": t("device.bms_software_version"),
            "dtu_software_version": t("device.dtu_software_version"),
            "gnss_satellite_used_count": t("device.gnss_satellite_used_count"),
            "gprs_apn": t("device.gprs_apn"),
            "gprs_total_data_used": t("device.gprs_total_data_used"),
            "gps_satellite_in_view_count": t("device.gps_satellite_in_view_count"),
            "gps_signal_strength": t("device.gsm_signal_strength"),
            "gps_status": t("device.gps_state"),
            "gsm_signal_strength": t("device.gsm_signal_strength"),
            "iccid":"ICCID",
            "imei": "IMEI",
            "iot_temperature": t("device.iot_temperature"),
            "location_angle": t("device.location_angle"),
            "location_latitude": t("device.latitude"),
            "location_longitude": t("device.longitude"),
            "location_speed": t("device.speed"),
            "system_error_status": '错误计数',

            "battery_chem_id": "电芯型号",
            "battery_current": t("device.current"),
            "battery_cycle_count": t("device.cycle_count"),
            "battery_manufacture_date": t("device.manufacture_date"),
            "battery_manufacture_name": t("device.manufacture_name"),
            "battery_name":t("device.name"),
            "battery_rated_capacity": t("device.rated_capacity"),
            "battery_rated_voltage": t("device.rated_voltage"),
            "battery_remaining_capacity": t("device.remaining_capacity"),
            "battery_soc":t('device.soc'),
            "battery_temperature": t("device.temperature"),
            "battery_version": t("device.version"),
            "battery_voltage": t("device.voltage"),
            "bms_bar_code": t("device.bms_bar_code"),

            "cell_voltage_list_0": '电芯电压1',
            "cell_voltage_list_1": '电芯电压2',
            "history": '电池最值记录',
        };

        for (let key in p) {
            let value = p[key];
            let name = frameKeyNaming[key] || '';
            if (!name) {
                continue
            }
            addItem(name, value)
        }
    }

    let type = frame['type'] || 0;
    switch (type) {
        case 1: {
            addHead(t(/*认证*/'frame.type.authentication'));

        } break;

        case 2: {
            addHead(t(/*告警*/'frame.type.warning'));
        } break;

        case 3: {
            addHead(t(/*上报*/'frame.type.escalation'));
            let data = publishFrame(runParser(packet.data))
            // console.log('data:', data, 'frame:', frame)
            parsePayload(data);
            // parsePayload(frame);
        } break;

        case 4: {
            addHead(t(/*心跳*/'frame.type.heartbeat'));

        } break;
    }

    return items.join(' ');
}